import { Component } from 'react';
import autobind from 'react-autobind';
import { withBus } from '../util/suber-hoc';
import _ from 'lodash';

class RoutesOnMap extends Component {
	constructor() {
		super();
		autobind(this);

		this.directionsService = null;
		this.directionsDisplays = null;
		this.debouncedMoveBounds = _.debounce(this.moveBounds, 500);
		this.legKey = '';
	}

	moveBounds() {
		this.props.map.fitBounds(this.directionsDisplays.getDirections().routes[0].bounds);
	}

	shouldComponentUpdate(nextProps, nextState) {
	    return !_.isEqual(nextProps.destinations, this.props.destinations);
	}

	componentDidUpdate(prevProps, prevState) {
		if(_.isNil(this.props.google) || _.isNil(this.props.map) || _.isNil(this.props.destinations)) {
			return;
		}

		const google = this.props.google;
		const map = this.props.map;
		const dest = this.props.destinations;

	    if(!this.directionsService) {
	    	this.directionsService = new google.maps.DirectionsService();
	    }

	    if(this.directionsService) {
			const legs = dest.length - 1;
			if(legs < 1) {
				return;
			}

            const legKey = _.tail(dest).reduce((a, d) => `${a}-${d.name}${!!d.sleep ? '1' : '0'}`, dest[0].name);
			console.log("Processing directions for ", legKey);

			if(legKey !== this.legKey) {
                const nextMonday = new Date();
                nextMonday.setDate(nextMonday.getDate() + (7 - nextMonday.getDay()) % 7 + 1);

                const request = {
                    origin: dest[0].name,
                    destination: dest[dest.length - 1].name,
                    waypoints: _.slice(dest, 1, dest.length - 1).map(d => ({ location: d.name, stopover: !!d.sleep })),
                    travelMode: 'DRIVING',
                    provideRouteAlternatives: false,
                    optimizeWaypoints: false,
                    drivingOptions: {
                        departureTime: nextMonday,
                        trafficModel: 'optimistic'
                    }
                };

                console.log("Request: ", request);

                this.directionsService.route(request, (response, status) => {
                    if (status === 'OK') {
                        console.log("Setting route for direction display " + legKey);

                        _.forEach(response.routes[0].legs, (leg, i) => {
                            const waypointLegKey = `${dest[i].name}-${dest[i+1].name}`;
                            //console.log("Sending distance for " + waypointLegKey, leg);
                            this.props.bus.send('DISTANCE_AVAILABLE', {
                                legKey: waypointLegKey,
                                distance: leg.distance,
                                duration: leg.duration
                            });
                        });

                        if(!this.directionsDisplays) {
                            this.directionsDisplays = new google.maps.DirectionsRenderer({
                                suppressMarkers: false,
                                preserveViewport: true,
                                map,
                                directions: response
                            });
                        } else {
                            this.directionsDisplays.setDirections(response);
                        }

                        this.debouncedMoveBounds();

                    } else if(status === "NOT_FOUND") {
                        const missingPoint = _.findIndex(response.geocoded_waypoints, w => (w.geocoder_status === "ZERO_RESULTS"));
                        if(missingPoint === -1) {
                            console.log("Unknown reason for geocoder failure", response);
                            return;
                        }

                        const place = (missingPoint === 0) ? response.request.origin : response.request.destination;
                        console.log("Unable to resolve search for: ", place);
                        this.props.bus.send('UNABLE_TO_RESOLVE', {
                            name: place
                        });

                    } else {
                        console.warn("Route request failed", status, response);
                    }
                });

                this.legKey = legKey;
            }
	    }
	}

	render() {
		return null;
	}
}

export default withBus(RoutesOnMap);


// WEBPACK FOOTER //
// ./src/components/RoutesOnMap.js